/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React, { type CSSProperties, type ReactNode } from 'react';

import { keyframes } from '@compiled/react';

import { css, jsx } from '@atlaskit/css';

export const FEED_SECTION_ANIMATION_DELAY_MS = 90;

const feedSectionEntrance = keyframes({
	'0%': { opacity: 0, transform: 'translate3d(0, 12px, 0)' },
	'60%': { opacity: 1 },
	'100%': { opacity: 1, transform: 'none' },
});

const animatedFeedSectionStyles = css({
	animationName: feedSectionEntrance,
	animationDuration: '500ms',
	animationTimingFunction: 'cubic-bezier(0.16, 1, 0.3, 1)',
	animationFillMode: 'backwards',
	'@media (prefers-reduced-motion: reduce)': {
		animation: 'none',
		transition: 'none',
	},
});

interface AnimatedFeedSectionProps {
	children: ReactNode;
	index: number;
	isEnabled: boolean;
	testId?: string;
}

export const AnimatedFeedSection = ({
	children,
	index,
	isEnabled,
	testId,
}: AnimatedFeedSectionProps): JSX.Element => {
	if (!isEnabled) {
		return <React.Fragment>{children}</React.Fragment>;
	}

	const style: CSSProperties = {
		animationDelay: `${index * FEED_SECTION_ANIMATION_DELAY_MS}ms`,
	};

	return (
		<div css={animatedFeedSectionStyles} data-testid={testId} style={style}>
			{children}
		</div>
	);
};
